// extracted by mini-css-extract-plugin
module.exports = {"container":"form-date_container__1wOcS","label":"form-date_label__3DMfc","error":"form-date_error__UnBOL","borderErr":"form-date_borderErr__R_15h"};